import { FormControl } from '@angular/forms';

export enum OrderFormKeys {
	TABLE_NUMBER = 'tableNumber',
	EMAIL = 'email',
	PHONE = 'phone',
	AGB = 'agb',
}
export type OrderForm = {
	[OrderFormKeys.TABLE_NUMBER]: string;
	[OrderFormKeys.EMAIL]: string;
	// [OrderFormKeys.PHONE]: any;
	[OrderFormKeys.AGB]: boolean;
};

export type ControlsOf<T> = {
	[K in keyof T]: FormControl<T[K] | null>;
};
